import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage'

/**
 * ボット画像をFirebase Storageへアップロードし、公開ダウンロードURLを返す。
 * MeetingBaaSはこのURLを直接取得するため、トークン付きダウンロードURLを使用する。
 */
export async function uploadBotImage(file: File, orgId: string): Promise<string> {
  if (!file.type.startsWith('image/')) {
    throw new Error('画像ファイルを選択してください')
  }
  if (file.size > 5 * 1024 * 1024) {
    throw new Error('画像は5MB以下にしてください')
  }
  const storage = getStorage()
  const path = `bot-images/${orgId}/${Date.now()}_${file.name}`
  const storageRef = ref(storage, path)
  await uploadBytes(storageRef, file)
  return getDownloadURL(storageRef)
}
